export function useDraftRegenerated() {
    const state = useState<{ assignmentId: number; ts: number } | null>('draft-regenerated', () => null);

    function notifyRegenerated(assignmentId: number) {
        state.value = { assignmentId, ts: Date.now() };
    }

    return { lastRegenerated: state, notifyRegenerated };
}
